import React from "react";

import { HubDialogWrapper } from "../HubDialogWrapper";
import ShipmentDetailsDialogContent from "./ShipmentDetailsDialogContent";

export const ShipmentDetailsDialog = ({ returning }) => {
  return (
    <HubDialogWrapper maxWidth="md" name="edit-shipping-details">
      <ShipmentDetailsDialogContent returning={returning} />
    </HubDialogWrapper>
  );
};

export default ShipmentDetailsDialog;
